import { render } from "./SeHelpLicenseAgreement.vue?vue&type=template&id=132af589"
import script from "./SeHelpLicenseAgreement.vue?vue&type=script&lang=js"
export * from "./SeHelpLicenseAgreement.vue?vue&type=script&lang=js"

import "./SeHelpLicenseAgreement.vue?vue&type=style&index=0&id=132af589&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__